import { FC, useContext } from 'react';
import { Button } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import { useSnapshot } from 'valtio';
import { formStore } from '../../store';
import { SidebarControlContext } from '../../providers/SidebarControlContext';

/**
 * Form control bar button that opens the sidebar on its Timeline view.
 *
 * Rendered by `FormControl` directly next to `FormRemindersButton` (SYD-2674),
 * and, like it, only while a form is loaded. Subscribes to the single leaf
 * `form.data.docId`, which is present exactly while the form document is loaded,
 * so edits to the form do not re-render it.
 */
export const FormTimelineButton: FC = () => {
  const formDocId = useSnapshot(formStore.state).form.data?.docId;
  const sidebarControl = useContext(SidebarControlContext);

  if (!formDocId) {
    return null;
  }

  return (
    <Button
      type="text"
      icon={<HistoryOutlined style={{ fontSize: 19 }} />}
      onClick={() => sidebarControl?.openTimelineSidebar()}
      aria-label="Open form timeline"
    />
  );
};
